import React, { useRef, useEffect } from "react";
import { Bold, Italic } from "lucide-react";

const FONTS = [
  { label: "Nunito", value: "Nunito", cls: "font-body" },
  { label: "Cormorant", value: "Cormorant Garamond", cls: "font-serif" },
  { label: "Raleway", value: "Raleway", cls: "font-sans" },
];

// Editor de texto enriquecido: aplica fuente / negrita / cursiva
// SOLO al texto seleccionado dentro del contenido del artículo.
export default function RichTextEditor({ value, onChange, placeholder }) {
  const ref = useRef(null);

  useEffect(() => {
    if (ref.current && ref.current.innerHTML !== (value || "")) {
      ref.current.innerHTML = value || "";
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleInput = () => {
    if (ref.current && onChange) onChange(ref.current.innerHTML);
  };

  // onMouseDown preventDefault mantiene la selección activa en el editor,
  // por eso execCommand se aplica directamente al texto seleccionado.
  const exec = (command, arg = null) => {
    try {
      document.execCommand("styleWithCSS", false, true);
    } catch (e) {}
    document.execCommand(command, false, arg);
    handleInput();
  };

  const btn =
    "flex items-center justify-center h-9 rounded-lg border border-amber/40 bg-cream text-ink/75 hover:border-plum hover:text-plum transition-colors";

  return (
    <div className="border border-amber/40 rounded-xl overflow-hidden">
      <div className="flex flex-wrap items-center gap-2 bg-amber/20 px-3 py-2 border-b border-amber/40">
        <span className="text-xs font-body text-ink/50 mr-1">Fuente:</span>
        {FONTS.map((f) => (
          <button
            key={f.value}
            type="button"
            onMouseDown={(e) => e.preventDefault()}
            onClick={() => exec("fontName", f.value)}
            className={`${btn} px-3 text-sm ${f.cls}`}
            title={`Aplicar ${f.label}`}
          >
            {f.label}
          </button>
        ))}
        <span className="w-px h-6 bg-amber/50 mx-1" />
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec("bold")} className={`${btn} w-9 font-bold`} title="Negrita">
          <Bold size={16} />
        </button>
        <button type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => exec("italic")} className={`${btn} w-9 italic`} title="Cursiva">
          <Italic size={16} />
        </button>
        <span className="text-xs font-body text-ink/45 ml-1 hidden md:inline">
          Selecciona un texto y pulsa el formato
        </span>
      </div>
      <div
        ref={ref}
        contentEditable
        suppressContentEditableWarning
        onInput={handleInput}
        data-placeholder={placeholder || "Escribe el contenido del artículo..."}
        className="rte-content min-h-[180px] px-4 py-3 font-body text-ink/80 outline-none leading-relaxed bg-cream"
      />
    </div>
  );
}
